var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDokument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    fill: "currentColor",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.626 2.304h20.748v27.392H5.626V2.304zM3.822.5h24.356v31H3.822V.5zm4.429 7.545h15.498V6.241H8.251v1.804zm15.498 2.952H8.251V9.193h15.498v1.804zM8.251 13.95h15.498v-1.805H8.251v1.805z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDokument);
export default __webpack_public_path__ + "static/media/dokument.6dae8ca5.svg";
export { ForwardRef as ReactComponent };